/**
 * Shared backend-verified outcome classification for a polled/refreshed
 * Purchase status. Extracted out of `useCreatePurchase.ts` so every caller
 * that polls `getPurchase` (single "Buy Now" checkout, Cart's per-order
 * payment) classifies a status identically — deliberately an explicit
 * allow-list, not "anything not still-pending means success" (a real bug,
 * caught in code review: a backend-verified FAILED/CANCELLED/EXPIRED status
 * was being reported to the customer as "Payment successful"). A future new
 * PurchaseStatus value must fail loudly (falls through to "still polling"),
 * never silently be treated as paid.
 */
import type { Purchase } from './types';

export const SUCCESS_STATUSES = new Set<Purchase['status']>([
  'PAYMENT_COMPLETED',
  'FULFILLMENT_IN_PROGRESS',
  'COMPLETED',
]);
export const FAILURE_STATUSES = new Set<Purchase['status']>(['FAILED', 'CANCELLED', 'EXPIRED']);

export type PurchaseOutcome = 'paid' | 'payment-failed' | null;

export function classifyPurchaseOutcome(status: Purchase['status']): PurchaseOutcome {
  if (SUCCESS_STATUSES.has(status)) return 'paid';
  if (FAILURE_STATUSES.has(status)) return 'payment-failed';
  return null;
}
